import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  TRACE: number = 1;
  DEBUG: number = 2;
  WARN: number = 3;
  ERROR: number = 4;
  CRITICAL: number = 5;

  logLevel: number = 1;


  constructor() { 
    this.logLevel = this.TRACE;
  }

  trace(o: any) {
    if (this.TRACE >= this.logLevel) {
      console.log(o);
    }
  }

  debug(o: any) {
    if (this.DEBUG >= this.logLevel) {
      console.log(o);
    }
  }

  warn(o: any) {
    if (this.WARN >= this.logLevel) {
      console.log(o);
    }
  }

  error(o: any) {
    if (this.ERROR >= this.logLevel) {
      console.log(o);
    }
  }

  critical(o: any) {
    if (this.CRITICAL >= this.logLevel) {
      console.log(o);
    }
  }

  setLogLevel(level: number) {
    this.logLevel = level;
  }
}
